export default function create(options) {
  return [{
    ...options,
    easing: 'sineInOut',
    keyframes: [{
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }];
  /*
   * @keyframes <name> {
   *   from {
   *     opacity: 0;
   *   }
   *   to {
   *     opacity: 1;
   *   }
   * }
   *
   * #target {
   *   animation: <name> <duration> <delay> <easing> backwards;
   * }
   */
}
//# sourceMappingURL=FadeIn.js.map